module.exports = __webpack_public_path__ + "img/title2.b52e271b.png";